/**
 * internet-safety-tips页面配置
 */
export default {
  title: 'Internet Safety Tips',
  content: `
    <p>1. Please do not provide personal information, such as full name, home address, social security number, telephone number, or email address.</p>
    <p>2. Please dress for the class, just as you do in a classroom.</p>
    <p>3. Please be respectful to your classmates. Think before you write or speak.</p>
    <p>4. Please do not send or upload inappropriate text, photos, or videos through the platform.</p>
    <p>5. Think Academy has zero tolerance for cyberbullying. If you see cyberbullying or any other improper behavior, please report it using the report button located at the upper right corner of the screen.</p>
    `,
}
